import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-chat-box-message-count-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfChatBoxMessageCountIconProps extends SvgIconProps {}

/**
 * Component used to display Chat box message count icon
 * @param props -CcfChatBoxMessageCountIconProps
 * @example <CcfChatBoxMessageCountIcon />
 * @returns
 */
export function CcfChatBoxMessageCountIcon(
  props: CcfChatBoxMessageCountIconProps
) {
  return (
    <SvgIcon
      {...props}
      width="20"
      height="10"
      viewBox="0 0 20 10"
      fill="none"
    >
      <path
        d="M15.526 1.40796H5.70801C3.22273 1.40796 1.20801 3.42268 1.20801 5.90796C1.20801 8.39324 3.22273 10.408 5.70801 10.408H15.526C18.0113 10.408 20.026 8.39324 20.026 5.90796C20.026 3.42268 18.0113 1.40796 15.526 1.40796Z"
        fill="#FFB000"
      />
      <path
        d="M15.526 0.907959H5.70801C2.94658 0.907959 0.708008 3.14654 0.708008 5.90796C0.708008 8.66938 2.94658 10.908 5.70801 10.908H15.526C18.2874 10.908 20.526 8.66938 20.526 5.90796C20.526 3.14654 18.2874 0.907959 15.526 0.907959Z"
        stroke="white"
      />
      <path
        d="M10.718 7.80592C11.6818 7.80592 12.463 7.02465 12.463 6.06092C12.463 5.09718 11.6818 4.31592 10.718 4.31592C9.75429 4.31592 8.97302 5.09718 8.97302 6.06092C8.97302 7.02465 9.75429 7.80592 10.718 7.80592Z"
        fill="white"
      />
      <path
        d="M6.06403 7.80592C7.02777 7.80592 7.80903 7.02465 7.80903 6.06092C7.80903 5.09718 7.02777 4.31592 6.06403 4.31592C5.10029 4.31592 4.31903 5.09718 4.31903 6.06092C4.31903 7.02465 5.10029 7.80592 6.06403 7.80592Z"
        fill="white"
      />
      <path
        d="M15.372 7.80592C16.3358 7.80592 17.117 7.02465 17.117 6.06092C17.117 5.09718 16.3358 4.31592 15.372 4.31592C14.4083 4.31592 13.627 5.09718 13.627 6.06092C13.627 7.02465 14.4083 7.80592 15.372 7.80592Z"
        fill="white"
      />
    </SvgIcon>
  );
}

export default CcfChatBoxMessageCountIcon;
